// extracted by mini-css-extract-plugin
module.exports = {"campaign-info":"CampaignInfo_campaign-info__Mg0__"};